import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Typography, Grid, Box, ListItem, List, Button, Link } from '@material-ui/core';
import Footer from '../UI-Component/Footer';
import OffreMarqueBlanche from '../../images/offre_marque_blanche.pdf';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      marginTop: "100px",
    },
    homeContainer: {
      backgroundColor: "whitesmoke",
      paddingTop: "40px",
      paddingBottom: "50px"
    },
    boxContainer: {
      backgroundColor: '#f9f9f9 !important',
      borderRadius: 10,
      boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
      padding: 20,
      marginBottom: 40,
    },
    bold: {
      color: theme.palette.secondary.main,
      fontWeight: 'bold',
    },
    simpleText: {
      fontWeight: 'normal',
    },
    flexHeightDesktop: {
      height: 'auto',
      justifyContent: 'center',
      borderRadius: '20px',
      [theme.breakpoints.down('sm')]: {
        height: '100%',
      },
    },
    listMooveContainer: {
      [theme.breakpoints.down('sm')]: {
        width: 'unset',
      },
      display: 'flex',
      "& ul ": {
        backgroundColor: '#f9f9f9!important',
        padding: 15,
        borderRadius: 15,
        width: '100%'
      }
    },
    decimalList: {
      counterReset: 'list-counter',
    },
    listMooveDecimal: {
      position: 'relative',
      margin: '0',
      display: 'list-item',
      counterIncrement: 'list-counter',
      fontSize: 19,
      '&::before': {
        content: 'counter(list-counter) ". "',
        position: 'absolute',
        left: 0,
        height: '100%',
        color: theme.palette.secondary.main,
        fontFamily: ['Dosis', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
        fontWeight: 'bold',
      },
      '& p': {
        margin: '0',
        marginLeft: '20px',
        padding: '0px',
        fontWeight: 'normal',
      },
    },
    listMoove: {
      position: 'relative',
      margin: '0',
      '&::before': {
        content: '"*"',
        position: 'absolute',
        left: 0,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '30px',
        width: '30px',
        height: '100%',
        fontSize: 45,
        color: theme.palette.secondary.main,
      },
      '& p': {
        margin: '0',
        marginLeft: '20px',
        padding: '0px',
        fontWeight: 'normal',
      },
    },
    simpleList: {
      position: 'relative',
      margin: '0',
      '&::before': {
        content: '"."',
        position: 'absolute',
        top: -20,
        height: '100%',
        fontSize: 45,
        color: theme.palette.secondary.main,
      },
      '& p': {
        margin: '0',
        marginLeft: '20px',
        padding: '0px',
        fontWeight: 'normal',
      },
    },
    actionContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        display: 'inline',
      },
    },
    buttonStyle: {
      minWidth: 'unset',
      lineHeight: '18px',
      padding: '0px 12px',
      height: 44,
      margin: '7px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        margin: '15px'
      },
      '&:hover': {
        '& a': {
          color: '#E5087E',
          textTransform: 'none',
          textDecoration: 'none',
        }
      },
      '& a': {
        fontWeight: 600,
        color: '#fff',
        textDecoration: 'none',
        width: '100%',
        '&:hover': {
          color: '#E5087E',
        },
      },
    },
    reverseButtonStyle: {
      lineHeight: '18px',
      padding: '0px 12px',
      height: 44,
      margin: '7px',
      color: '#E5087E',
      backgroundColor: '#ffffff',
      fontWeight: 'bold',
      '&:hover': {
        textTransform: 'none',
        textDecoration: 'none',
        backgroundColor: '#E5087E',
        color: '#ffffff',
        '& a': {
          color: '#ffffff',
          textTransform: 'none',
          textDecoration: 'none',
        },
      },
      '&:focus, &.focus': {
        backgroundColor: '#E5087E',
        color: '#ffffff',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginBottom: '20px',
      },
    },
    btnLink: {
      color: '#e5087e',
      textTransform: 'none',
      textDecoration: 'none',
      pointer: 'cursor',
      fontSize: '16px',
      '&:hover': {
        color: '#E5087E',
      },
    },
    btnLinkReverse: {
      color: '#e5087e',
      textTransform: 'none',
      fontSize: '16px',
      '&:hover': {
        backgroundColor: '#E5087E',
        color: '#ffffff',
        textTransform: 'none',
        textDecoration: 'none',
      },
    },
    tabContainer: {
      '& .MuiTabs-flexContainer': {
        justifyContent: 'center',
        '& button': {
          color: '#888',
        },
        '& button.Mui-selected': {
          color: '#E5087E',
        }
      }
    },
    simpleLink: {
      color: '#e5077f',
      fontWeight: 'bold',
      fontFamily: 'Dosis',
      fontSize: '18px',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
        textTransform: 'none',

      },
    },
    underlineLink: {
      color: '#e5077f',
      fontWeight: 'bold',
      fontFamily: 'Dosis',
      fontSize: '18px',
      textDecoration: 'underline',
      '&:hover': {
        textTransform: 'none',

      },
    },
    textParagraph: {
      fontWeight: 'normal',
    },
    paragraphTitle: {
      fontWeight: 'bold',
    }
  }),
);


const WhiteLabel = (props) => {
  const { page } = props;
  const [value, setValue] = useState(0);
  const classes = useStyles();
  const history = useHistory();

  function navigate(path) {
    history.push(path);
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClick = (event) => {
    console.log(event);
  };

  return (
    <>
      <main style={{ overflowX: 'hidden' }}>
        <div className={classes.root}>
          <Grid container className={classes.homeContainer}>

            <Grid item xs={12}>
              <Grid item lg={12} className={classes.serviceContainer}>
                <div>
                  <Typography variant="h1" style={{ textAlign: 'center', width: '100%' }}>Explication 101 d’une marque blanche</Typography>
                </div>
                <Grid container className={classes.homeContainer}>
                  <Grid item md={2} xs={12}>
                  </Grid>
                  <Grid item md={8} xs={12} className={classes.boxContainer}>
                    <Grid item lg={12} className={classes.serviceContainer}>
                      <Grid item xs={12} md={12}>
                        <Typography variant="h3" className={classes.paragraphTitle}>
                          📌 Qu'est-ce qu'un logiciel en marque blanche ? (Explication 101) !
                        </Typography>
                        <Typography className={classes.textParagraph}>
                          Un logiciel en marque blanche est une solution développée par une entreprise,
                          mais utilisée et commercialisée sous le nom et l’identité d’une autre entreprise.
                          Il vous permet de proposer un service numérique à vos clients sans avoir à le développer vous-même.
                        </Typography>
                        <Typography variant="h3" className={classes.paragraphTitle}>
                          🏢 Un exemple concret :
                        </Typography>
                        <Typography className={classes.textParagraph}>
                          Imaginons que vous souhaitiez lancer votre propre plateforme de recrutement en ligne...
                        </Typography>
                        <Typography className={classes.textParagraph}>
                          ✅ Plutôt que de créer votre propre solution, vous utilisez une plateforme existante et personnalisable.<br />
                          ✅ Vous ajoutez votre logo, vos couleurs et vos propres fonctionnalités.<br />
                          ✅ Vos clients accèdent à une plateforme sous votre marque.
                        </Typography>
                        <Typography variant="h3" className={classes.paragraphTitle}>
                          🤔 Pourquoi choisir une solution en marque blanche ?
                        </Typography>
                        <Box className={`${classes.listMooveContainer} ${classes.flexHeightDesktop}`}>

                          <List className={classes.decimalList}>
                            <ListItem className={classes.listMooveDecimal}>
                              <Typography className={classes.bulletPoint}>
                                Un gain de temps considérable ⏳
                              </Typography>
                              <Typography className={classes.textParagraph}>
                                Vous déployez votre propre service en quelques semaines, sans attendre des mois de développement.
                              </Typography>
                            </ListItem>
                            <ListItem className={classes.listMooveDecimal}>
                              <Typography className={classes.bulletPoint}>
                                Une économie importante 💰
                              </Typography>
                              <Typography className={classes.textParagraph}>
                                Le coût est bien inférieur à celui d’un logiciel conçu sur mesure.
                              </Typography>
                            </ListItem>
                            <ListItem className={classes.listMooveDecimal}>
                              <Typography className={classes.bulletPoint}>
                                Une personnalisation totale 🎨
                              </Typography>
                              <Typography className={classes.textParagraph}>
                                Vous adaptez l’interface et les fonctionnalités à votre image et à vos besoins. Vous pouvez en amont choisir les options que vous souhaitez offrir ou pas à vos membres ou clients.
                              </Typography>
                            </ListItem>
                            <ListItem className={classes.listMooveDecimal}>
                              <Typography className={classes.bulletPoint}>
                                Des mises à jour et un support inclus 🔄
                              </Typography>
                              <Typography className={classes.textParagraph}>
                                Le prestataire qui a conçu le logiciel s’occupe des améliorations et de la maintenance.
                              </Typography>
                            </ListItem>
                            <ListItem className={classes.listMooveDecimal}>
                              <Typography className={classes.bulletPoint}>
                                Une technologie fiable, évolutive et immédiatement testable📈
                              </Typography>
                              <Typography className={classes.textParagraph}>
                                Vous profitez d’une solution robuste, testée et améliorée en permanence.
                              </Typography>
                            </ListItem>
                          </List>
                        </Box>
                        <Typography variant="h3" className={classes.paragraphTitle}>
                          👥 Qui utilise un logiciel en marque blanche ?
                        </Typography>
                        <List dense>
                          <ListItem className={classes.simpleList}>
                            <Typography className={classes.bulletPoint}>
                              Les entreprises en générales🏦 : Une entreprise locale peut proposer une application mobile développée par un prestataire dans plusieurs autres entreprises, mais avec son propre logo et ses services spécifiques.
                            </Typography>
                          </ListItem>
                          <ListItem className={classes.simpleList}>
                            <Typography className={classes.bulletPoint}>
                              Les plateformes de livraison 🚴‍♂️ : Un service de livraison peut utiliser un logiciel existant et l’adapter à sa marque.
                            </Typography>
                          </ListItem>
                          <ListItem className={classes.simpleList}>
                            <Typography className={classes.bulletPoint}>
                              Les sites ou outils de recrutement 👨‍💼 : Un site d’emploi peut offrir une plateforme clé en main sous sa propre identité.
                            </Typography>
                          </ListItem>
                        </List>
                        <Typography variant="h3" className={classes.paragraphTitle}>
                          🔥 Pourquoi est-ce une solution intéressante ?
                        </Typography>
                        <Typography className={classes.textParagraph}>
                          Si vous souhaitez proposer une solution digitale innovante sans les coûts et les risques d’un développement en interne, la marque blanche est une excellente alternative. Vous pouvez ainsi vous concentrer sur votre activité principale, tout en offrant à vos clients une technologie performante et professionnelle sous votre propre marque. 🚀
                        </Typography>
                        <br />
                        <br />

                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div className={classes.actionContainer}>
                      <Typography className={classes.bulletPoint}>
                        Prêt à en savoir plus ?
                      </Typography>
                    </div>
                    <div className={classes.actionContainer}>
                      <Button
                        size='sm'
                        type="submit"
                        className={classes.reverseButtonStyle}
                      >
                        <Link className={classes.btnLinkReverse} href={"https://calendly.com/moovejob/demo"} target="_blank" >
                          Demander une démo
                        </Link>
                      </Button>

                      <Button
                        size='sm'
                        type="submit"
                        className={classes.reverseButtonStyle}
                      >
                        <Link className={classes.btnLinkReverse} to={OffreMarqueBlanche}
                          href={OffreMarqueBlanche}
                          without="true"
                          rel="noopener noreferrer"
                          target="_blank" >
                          Télécharger l’offre en PDF
                        </Link>
                      </Button>

                      <Button
                        size='sm'
                        type="submit"
                        className={classes.reverseButtonStyle}
                      >
                        <Link className={classes.btnLinkReverse} href="mailto:communication@moovejob.com">
                          Nous contacter
                        </Link>
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <Footer />
      </main>
    </>
  );
};

export default WhiteLabel;
